<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
			persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card style="margin: 0px;">
        <v-toolbar class="dialog-toolbar fixNotchPaddingTop">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>
						<v-icon color="primary" style="top: -2px;">mdi-alert</v-icon>
						Alertas sanitarias
					</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="padding: 0;" class="fixNotchPaddingTop">
				<div class="dialog-paged-bk-color" :style="{ paddingBottom: showMoreContent ? '0' : '12px' }">
					<v-skeleton-loader v-if="isLoading" type="list-item-avatar-two-line" class="mx-auto" max-width="90%" style="padding-top: 20px;"/>
					<v-alert v-if="!isLoading && items.length == 0" type="error" style="margin: 20px;">
						No se han encontrado datos
					</v-alert>
					<v-list ref="alertList" v-if="!isLoading" style="padding: 0;">
							<div v-for="item in items" :key="item.id">
								<AlertItem :data="item" @open-external-content="openUrl(arguments)"/>
								<v-divider v-if="items.length == 0 || item.id != items[items.length-1].id"/>
							</div>
					</v-list>

					<v-row v-if="showMoreContent">
						<v-col style="text-align: center;">
							<a @click="addMoreContent()">Mostrar más contenido</a>
						</v-col>
					</v-row> 
            </div> 
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from '../../api/icoev';
import BaseModule from "./BaseModule";
import AlertItem from "./AlertItem";

export default {
	name: "AlertsDialog",
	mixins: [ BaseModule ],
	components: {
		AlertItem
	},
	data() {
		return {
			isLoading: false,
			dialog: false,
			page: 0,
			showMoreContent: false,
			items: [],
			selector: null,
		}
	},
	methods: {
		open: function(clearCache) {
			this.page = 0;
			this.showMoreContent = false;
			this.items = [];

			this.dialog = true;

			if (clearCache) {
				api.clearAlertsCache();
			}

			this.$nextTick(() => {
				this.listarItems();
			});
		},
		isOpen: function() {
			return this.dialog;
		},
		close: function() {
			this.dialog = false;
		},
		listarItems: function() {
			this.$log.debug("AlertsDialog - listarItems()");

			this.isLoading = true;

			api.getAlerts(this.page,
				res => {
					this.isLoading = false;

					if (!res.rsOK) {
						this.$emit('alert-event', { text: res.message, color: 'error', timeout: 3000 });
						return;
					}

					if (res.entities.length == 0) {
						return;
					}
				
					this.items.push(...res.entities);

					this.showMoreContent = res.hasMoreData;

					if (this.selector) {
						this.$nextTick(() => {
							var anchor = this.$refs.alertList.$el.querySelector(this.selector);
							if (anchor) {
								anchor.scrollIntoView();
							}
						});
					}
				},
				err => {               
					this.isLoading = false;     
					this.$log.error(err);
					this.$emit('alert-event', { text: 'Error al listar las alertas sanitarias', color: 'error', timeout: 3000 });
				}
			);
		},
		addMoreContent: function() {
			this.page++;
			this.selector = '#alert' + this.items[this.items.length - 1].id;
			this.listarItems();
		},
		openUrl: function(args) {
			this.$emit('open-external-content', args[0], args[1]);
		}
	},
}
</script>